import React, { Suspense, lazy, useCallback } from "react";
import { IAppsFields } from "../../../../types/appstore";
const Payroll = lazy(() => import("./Payroll"));
const Grow = lazy(() => import("./Grow"));
const Train = lazy(() => import("./Train"));
const Documents = lazy(() => import("./Documents"));
const Track = lazy(() => import("./Track"));
const ProCoach = lazy(() => import("./ProCoach"));
const TwoBrainBusiness = lazy(() => import("./TwoBrainBusiness"));
const Analytics = lazy(() => import("./Analytics"));
const Facebook = lazy(() => import("./Facebook"));
const SugarWod = lazy(() => import("./SugarWod"));
const Btwb = lazy(() => import("./Btwb"));
const DrivenNutrition = lazy(() => import("./DrivenNutrition"));
const Slack = lazy(() => import("./Slack"));
const Member = lazy(() => import("./Member"));
const Staff = lazy(() => import("./Staff"));
const Screens = lazy(() => import("./Screens"));
const CommittedClub = lazy(() => import("./CommittedClub"));
const BrandedApp = lazy(() => import("./BrandedApp"));
const RankTracking = lazy(() => import("./RankTracking"));
const Insurance = lazy(() => import("./Insurance"));

const Settings = ({ app }: { app: IAppsFields }) => {
  const SettingsPage = useCallback(() => {
    switch (app.settingComponent) {
      case "Payroll":
        return <Payroll />;
      case "Grow":
        return <Grow />;
      case "Train":
        return <Train />;
      case "Documents":
        return <Documents />;
      case "Track":
        return <Track />;
      case "ProCoach":
        return <ProCoach />;
      case "TwoBrainBusiness":
        return <TwoBrainBusiness />;
      case "Analytics":
        return <Analytics app={app} />;
      case "Facebook":
        return <Facebook app={app} />;
      case "SugarWod":
        return <SugarWod app={app} />;
      case "BTWB":
        return <Btwb app={app} />;
      case "DrivenNutrition":
        return <DrivenNutrition />;
      case "Slack":
        return <Slack app={app} />;
      case "Member":
        return <Member app={app} />;
      case "Staff":
        return <Staff app={app} />;
      case "BrandedApp":
        return <BrandedApp app={app} />;
      case "Screens":
        return <Screens />;
      case "CommittedClub":
        return <CommittedClub />;
      case "RankTracking":
        return <RankTracking />;
      case "Insurance":
        return <Insurance />;
      default:
        return <></>;
    }
  }, [app]);

  return (
    <Suspense fallback={false}>
      <SettingsPage />
    </Suspense>
  );
};

export default Settings;
